






import { Component, Vue } from 'vue-property-decorator';

import Loading from '@/components/common/Loading.vue';
import PageName from '@/router/PageName';

// トップページ(/first-access)に転送するのみのビュー。
//
// ネイティブアプリのログアウト挙動をトリガーするためのクッション。
// 最も安直な方法はルート定義のredirectを使用する方法だが、
// それではアラーム通知から起動した場合にログアウト挙動がトリガーされなかった。
@Component({
  components: {
    Loading,
  },
})
export default class Entrance extends Vue {
  // ライフサイクルフック
  mounted() {
    this.$router.replace({ name: PageName.TOP });
  }
}
